import { useMemo, useState } from 'react'

import type { TimelineData } from '@/modules/chatting/ui/chat-window/fan-info/ppv-stats/ppv-timeline/types'

export function usePagination(data: TimelineData[]) {
  const lastPageIndex = Math.ceil(data.length / 10) - 1
  const [pagination, setPagination] = useState({
    pageIndex: lastPageIndex,
    pageSize: 10,
  })

  const pageCount = Math.ceil(data.length / pagination.pageSize)

  const paginatedData = useMemo(() => {
    const end = Math.min(
      data.length -
        (pageCount - 1 - pagination.pageIndex) * pagination.pageSize,
      data.length,
    )
    const start = Math.max(0, end - pagination.pageSize)

    return data.slice(start, end)
  }, [data, pageCount, pagination.pageIndex, pagination.pageSize])

  return {
    paginatedData,
    pagination,
    pageCount,
    setPagination,
  }
}
